import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction, AlertDialogCancel } from "./ui/alert-dialog";
import { useTaal } from "@/contexts/TaalContext";

const TOOL_LABELS = {
  click_element: "Element aanklikken",
  type_text: "Tekst typen",
  form_fill: "Formulier invullen",
};

export default function ClawConfirmDialog({
  open,
  onOpenChange,
  pendingAction,
  onConfirm,
  onCancel,
}) {
  const { t } = useTaal();
  if (!pendingAction) return null;

  const tool = pendingAction.tool || "unknown";
  const label = TOOL_LABELS[tool] ? t(TOOL_LABELS[tool]) : tool;
  const description = pendingAction.description || `Execute ${tool}`;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("{wat} bevestigen", { wat: label })}</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>{t("De AI wil de volgende handeling uitvoeren:")}</p>
            <div className="bg-muted rounded-lg p-3 font-mono text-sm">
              {description}
            </div>
            {tool === "type_text" && pendingAction.args?.text && (
              <div className="bg-muted rounded-lg p-3 text-sm">
                <strong>{t("Tekst:")}</strong> {pendingAction.args.text}
              </div>
            )}
            {tool === "form_fill" && pendingAction.args?.fields && (
              <div className="bg-muted rounded-lg p-3 text-sm">
                <strong>{t("Velden:")}</strong>
                <ul className="list-disc list-inside mt-1">
                  {pendingAction.args.fields.map((f, i) => (
                    <li key={i}>
                      <code className="text-xs">{f.selector}</code>: {f.value}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>{t("Blokkeren")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>{t("Toestaan")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
